export const HELP_URL =
  'https://help.octopus.do/article/103-can-i-crawl-more-than-3000-pages-to-generate-a-sitemap'

export const UPGRADE_URL = '/pricing'

export const CRAWLER_ERRORS_DESCRIPTIONS =
  'https://help.octopus.do/article/95-error-crawling-website'

export const CRAWLER_EXCLUSIONS_URL =
  'https://help.octopus.do/article/164-adding-crawling-exclusions'
